import Cookies from "universal-cookie";
import { resetFetched } from "./userData";
import config from "../constants/config";

const cookies = new Cookies();

export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const UNAUTHORIZED = "UNAUTHORIZED";

export const validateThenLogin = tokenProp => async dispatch => {
  let result = {};

  // is the token in the cache?
  const token = tokenProp || cookies.get(config.JWT_COOKIE) || "";

  try {
    result = await fetch(`${config.API_ENDPOINT}/loggedin?token=${token}`).then(
      res => res.json()
    );
  } catch (err) {
    return dispatch({
      type: LOGIN_ERROR,
      payload: err
    });
  }

  if (result.status === 200) {
    dispatch(
      login({ token, userID: result.userID, LoginType: result.LoginType })
    );
  } else {
    dispatch({ type: UNAUTHORIZED });
  }
};

export const login = ({ token, userID, LoginType }) => dispatch => {
  // save/replace cookie
  cookies.set(config.JWT_COOKIE, token);

  dispatch({
    type: LOGGED_IN,
    payload: { token, userID, LoginType }
  });
};

export const logout = () => dispatch => {
  // delete cookie
  cookies.remove(config.JWT_COOKIE);

  // reset fetched data
  dispatch(resetFetched());

  dispatch({
    type: LOGGED_OUT
  });
};
